import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { HisInformationSetting } from "../../../../base/domain/his";
import { ICheckStyle, PatientProfileCheckKinds, TranscribeTargetKinds, IQuestionnaire, QuestionnaireType } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { ICheckObject } from "../objects";
import { ICheckStylePropertyEditable, IQuestionnairePropertyEditable } from "../properties";
import { AbstractCheckableObjectEditor } from "./AbstractCheckableObjectEditor";

export class CheckObjectEditor extends AbstractCheckableObjectEditor<ICheckObject> implements ICheckStylePropertyEditable, IQuestionnairePropertyEditable {
  constructor(source: ICheckObject | CheckObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._checkStyle = this.createPropertyEditor(s => s.checkStyle, (s, v) => s.checkStyle = v);
    this._questionnaire = this.createPropertyEditor(s => s.questionnaire, (s, v) => s.questionnaire = v);
  }

  getSelectableHisInformations(): HisInformationSetting[] {
    return this._specification.objects.check.hisInformations;
  }

  protected _checkStyle: IPropertyEditable<ICheckStyle>;
  protected _questionnaire: IPropertyEditable<IQuestionnaire>;

  checkStyle(): IPropertyEditable<ICheckStyle> {
    return this._checkStyle;
  }

  questionnaire(): IPropertyEditable<IQuestionnaire> {
    return this._questionnaire;
  }

  selectableQuestionnaireTypes(): (QuestionnaireType | undefined)[] {
    return [
      undefined,
      "choice",
    ];
  }

  isPatientProfileCheckKindSelectable(): boolean {
    return true;  // v45では常に選択可.
  }

  getSelectablePatientProfileCheckKinds(): PatientProfileCheckKinds[] {
    return this._specification.objects.check.patientProfileCheckKinds;
  }

  isGroupScopeSelectable(): boolean {
    return this._specification.objects.check.isGroupScopeSelectable;
  }

  getSelectableTranscribeTargets(): TranscribeTargetKinds[] {
    return this._specification.objects.check.transcription.targets;
  }

  getTypeName(): string {
    return "チェックボックス";
  }

  clone(): IFormatObjectEditable {
    return new CheckObjectEditor(this);
  }
}
